var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBarChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.75 14C14.75 14.4142 14.4142 14.75 14 14.75L11.3333 14.75C10.9191 14.75 10.5833 14.4142 10.5833 14L10.5833 2C10.5833 1.58579 10.9191 1.25 11.3333 1.25L14 1.25C14.4142 1.25 14.75 1.58579 14.75 2L14.75 14ZM13.25 13.25L13.25 2.75L12.0833 2.75L12.0833 13.25L13.25 13.25Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0835 14.0002C10.0835 14.4145 9.74771 14.7502 9.3335 14.7502L6.66683 14.7502C6.25262 14.7502 5.91683 14.4145 5.91683 14.0002L5.91683 5.78958C5.91683 5.37536 6.25262 5.03958 6.66683 5.03958L9.3335 5.03958C9.74771 5.03958 10.0835 5.37536 10.0835 5.78958L10.0835 14.0002ZM8.5835 13.2502L8.5835 6.53958L7.41683 6.53958L7.41683 13.2502L8.5835 13.2502Z",
    className: "icon-fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.4165 14.0002C5.4165 14.4145 5.08072 14.7502 4.6665 14.7502L1.99984 14.7502C1.58562 14.7502 1.24984 14.4145 1.24984 14.0002L1.24984 9.57891C1.24984 9.1647 1.58562 8.82891 1.99984 8.82891L4.6665 8.82891C5.08072 8.82891 5.4165 9.1647 5.4165 9.57891L5.4165 14.0002ZM3.9165 13.2502L3.9165 10.3289L2.74984 10.3289L2.74984 13.2502L3.9165 13.2502Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBarChart);
export default __webpack_public_path__ + "static/media/icon-bar-chart.8c3d94126e8d3b417c7e3866c01b2766.svg";
export { ForwardRef as ReactComponent };